import React, {CSSProperties, forwardRef, HTMLAttributes} from 'react'

/** A column that fills the space it gets (flex 1) and scrolls its content vertically. Rest props and the ref go to the <div>. */
const ScrollView = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(function ScrollView({style, children, ...rest}, ref) {
    const scrollStyle: CSSProperties = {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        overflowY: 'auto',
        width: '100%',
        ...style
    }

    return (
        <div {...rest} ref={ref} style={scrollStyle}>
            {children}
        </div>
    )
})

export default ScrollView
